import { aboutData } from "@/mocks/about";

export default function BrandStats() {
  return (
    <section className="py-16 md:py-24 bg-background-50">
      <div className="px-4 md:px-6 max-w-7xl mx-auto">
        <div className="flex flex-col lg:flex-row gap-10 lg:gap-16">
          <div className="flex-1">
            <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-50 mb-6 leading-snug">
              关于 {aboutData.brandName}
            </h2>
            <p className="text-sm md:text-base text-foreground-400 leading-relaxed mb-10 max-w-xl">
              {aboutData.intro}
            </p>

            <div className="grid grid-cols-3 gap-6 md:gap-10">
              {aboutData.stats.map((stat, i) => (
                <div
                  key={i}
                  className={`${i < aboutData.stats.length - 1 ? "border-r border-background-300/50" : ""} pr-4`}
                >
                  <p className="text-2xl md:text-4xl font-heading font-bold text-accent-500 mb-1">
                    {stat.value}
                  </p>
                  <p className="text-xs md:text-sm text-foreground-500">
                    {stat.label}
                  </p>
                </div>
              ))}
            </div>
          </div>

          <div className="flex-1 relative min-h-[300px] rounded-2xl overflow-hidden bg-gradient-to-br from-primary-900/60 via-background-100 to-primary-950/40">
            <div className="absolute inset-0">
              <div className="absolute top-10 left-10 w-32 h-32 rounded-2xl bg-background-200/30 rotate-12"></div>
              <div className="absolute top-20 right-16 w-24 h-24 rounded-full bg-primary-800/20"></div>
              <div className="absolute bottom-12 left-20 w-40 h-28 rounded-2xl bg-background-300/20 -rotate-6"></div>
              <div className="absolute bottom-16 right-10 w-20 h-20 rounded-xl bg-accent-900/15 rotate-45"></div>
              <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-48 h-48 rounded-full bg-primary-500/5"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}